import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Spinner from '@/src/components/common/Elements/Spinner/Spinner';
import NotAvailable from '@/src/components/notAvailable';
import { useRouterQuery } from '@/src/hooks/useRouterQuery';

import EmailEntryViewerPage from './EmailEntryViewerPage/EmailEntryViewerPage';
import EmailFileEntryViewerPage from './FileEntryViewerPage/EmailFileEntryViewerPage';
import WebappFileEntryViewerPage from './FileEntryViewerPage/WebappFileEntryViewerPage';

import { InboxProvider } from '../../store/inbox.store';
import { InboxEntryPanelProvider } from '../../store/inboxEntryPanel.store';
import { useTagsStore } from '../../store/tags.store';
import { InboxEntrySource, InboxEntryType } from '../../types';
import { useGetProjectPermissions } from '../../../api/getProjectPermissions';

const InboxEntryViewerPage = () => {
  const { projectId, inboxEntryId } = useParams<{ projectId: string; inboxEntryId: string }>();
  const routerQuery = useRouterQuery();
  const emailId = routerQuery.get('emailId') || '';
  const fileId = routerQuery.get('fileId') || '';
  const documentSource = routerQuery.get('source') || '';
  const documentType = routerQuery.get('type');

  const { data: permissions } = useGetProjectPermissions({
    projectId: Number(projectId),
  });
  const setPermissions = useTagsStore((state) => state.setPermissions);

  useEffect(() => {
    if (permissions && setPermissions) {
      setPermissions(permissions.data);
    }
  }, [permissions, setPermissions]);

  if (!inboxEntryId || !projectId) {
    return <Spinner />;
  }

  if (documentType !== InboxEntryType.THREAD.toLowerCase()) {
    if (documentSource === InboxEntrySource.WebApp) {
      return (
        <InboxProvider>
          <InboxEntryPanelProvider>
            <WebappFileEntryViewerPage
              fileId={+inboxEntryId}
              inboxEntryId={+inboxEntryId}
              projectId={projectId}
            />
          </InboxEntryPanelProvider>
        </InboxProvider>
      );
    } else {
      if (!emailId || !fileId) {
        return <NotAvailable />;
      }

      return (
        <InboxProvider>
          <InboxEntryPanelProvider>
            <EmailFileEntryViewerPage
              emailId={+emailId}
              inboxEntryId={+inboxEntryId}
              projectId={projectId}
              fileId={+fileId}
            />
          </InboxEntryPanelProvider>
        </InboxProvider>
      );
    }
  }

  if (!emailId) {
    return <NotAvailable />;
  }

  return (
    <React.Fragment>
      <InboxProvider>
        <InboxEntryPanelProvider>
          <EmailEntryViewerPage
            projectId={projectId}
            emailId={+emailId}
            inboxEntryId={+inboxEntryId}
            fileId={fileId ? +fileId : null}
          />
        </InboxEntryPanelProvider>
      </InboxProvider>
    </React.Fragment>
  );
};

export default InboxEntryViewerPage;
